module.exports = __webpack_public_path__ + "static/0a917c7a-757d-4472-8da4-27e3e77ab459-56bbec6ac2f6d6de1dcc7ebcd9d15aa1.jpeg";